// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-split-pane {
  --side-width: 240px;
  --side-min-width: 240px;
  --side-max-width: 240px;
}

ion-menu ion-content {
  --background: var(--ion-item-background, var(--ion-background-color, #fff));
  --overflow: auto;
}

ion-menu {
  --width: 240px;
  --max-width: 240px;
  width: 240px;
  max-width: 240px;
  border-right: 1px solid #e6edf5;
}

ion-menu ion-content {
  padding: 0 12px;
}

ion-menu ion-list {
  padding: 0 0 6px;
}

ion-menu ion-item {
  --background: transparent;
  --color: #4d617d;
  --min-height: 46px;
  --padding-start: 14px;
  --inner-padding-end: 12px;
  margin: 3px 0;
  border-radius: 9px;
  font-size: 13px;
}

ion-menu ion-item ion-icon {
  margin-right: 13px;
  color: #5a6f8b;
  font-size: 20px;
}

ion-menu ion-item.menu-item-active {
  --background: #ff6b1a;
  --color: #fff;
  box-shadow: 0 4px 10px rgba(255, 107, 26, 0.18);
}

ion-menu ion-item.menu-item-active ion-icon,
ion-menu ion-item.menu-item-active ion-label {
  color: #fff;
}

ion-menu ion-item.menu-item-active .menuimg {
  filter: brightness(0) invert(1);
}

.reports-menu-group {
  margin: 2px 0;
}

.reports-menu-group ion-accordion > ion-item {
  --background: transparent;
  --color: #4d617d;
}

.reports-menu-group ion-accordion.menu-accordion-active > ion-item {
  --color: #ff6b1a;
  font-weight: 700;
}

.reports-menu-group ion-accordion > ion-list {
  padding: 0 0 0 12px;
}

.reports-menu-group ion-accordion > ion-list ion-item {
  --min-height: 40px;
  --padding-start: 14px;
  font-size: 12px;
}

.menuimg {
  width: 30px;
  margin-right: 24px;
}

.logo {
  width: 90px;
  margin: 0 auto;
  display: block;
  padding: 0px 0 17px;
}

.user_info {
  display: flex;
  align-items: center;
  position: relative;
  padding: 14px 14px 10px;
}
.user_info .back_image {
  height: 40px;
  width: 40px;
  min-width: 40px;
  border-radius: 100%;
  background: lightgrey;
}
.user_info ion-label {
  font-family: "semi-bold";
  margin-left: 16px;
}
.user_info ion-icon {
  position: absolute;
  right: 16px;
  color: #a0abba;
}

.header_div {
  display: flex;
  align-items: center;
  padding: 16px;
  padding-right: 0px;
}
.header_div ion-label {
  color: grey;
  text-transform: uppercase;
  padding-right: 16px;
  font-size: 12px;
  white-space: nowrap;
}
.header_div div {
  width: 100%;
  height: 1px;
  background: lightgrey;
}

.image_div {
  padding: 0;
}

ion-item ion-label {
  font-family: "medium";
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAI;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,2EAAA;EACA,gBAAA;AACJ;;AAEA;EACI,cAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,+BAAA;AACJ;;AAEA;EAAuB,eAAA;AAEvB;;AADA;EAAoB,gBAAA;AAKpB;;AAHA;EACI,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAMJ;;AAHA;EACI,kBAAA;EACA,cAAA;EACA,eAAA;AAMJ;;AAHA;EACI,qBAAA;EACA,aAAA;EACA,+CAAA;AAMJ;;AAHA;;EAC+C,WAAA;AAO/C;;AALA;EAA8C,+BAAA;AAS9C;;AAPA;EACI,aAAA;AAUJ;;AAPA;EACI,yBAAA;EACA,gBAAA;AAUJ;;AAPA;EACI,gBAAA;EACA,gBAAA;AAUJ;;AAPA;EACI,mBAAA;AAUJ;;AAPA;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;AAUJ;;AAPA;EACI,WAAA;EACA,kBAAA;AAUJ;;AAPA;EACI,WAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;AAUJ;;AAPA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AAUJ;AARI;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;AAUR;AAPI;EACI,wBAAA;EACA,iBAAA;AASR;AANI;EACI,kBAAA;EACA,WAAA;EACA,cAAA;AAQR;;AAJA;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAOJ;AALI;EACI,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAOR;AAJI;EACI,WAAA;EACA,WAAA;EACA,qBAAA;AAMR;;AAFA;EACI,UAAA;AAKJ;;AADI;EACI,qBAAA;AAIR","sourcesContent":["    ion-split-pane {\n    --side-width: 240px;\n    --side-min-width: 240px;\n    --side-max-width: 240px;\n}\n\nion-menu ion-content {\n    --background: var(--ion-item-background, var(--ion-background-color, #fff));\n    --overflow: auto;\n}\n\nion-menu {\n    --width: 240px;\n    --max-width: 240px;\n    width: 240px;\n    max-width: 240px;\n    border-right: 1px solid #e6edf5;\n}\n\nion-menu ion-content { padding: 0 12px; }\nion-menu ion-list { padding: 0 0 6px; }\n\nion-menu ion-item {\n    --background: transparent;\n    --color: #4d617d;\n    --min-height: 46px;\n    --padding-start: 14px;\n    --inner-padding-end: 12px;\n    margin: 3px 0;\n    border-radius: 9px;\n    font-size: 13px;\n}\n\nion-menu ion-item ion-icon {\n    margin-right: 13px;\n    color: #5a6f8b;\n    font-size: 20px;\n}\n\nion-menu ion-item.menu-item-active {\n    --background: #ff6b1a;\n    --color: #fff;\n    box-shadow: 0 4px 10px rgba(255, 107, 26, .18);\n}\n\nion-menu ion-item.menu-item-active ion-icon,\nion-menu ion-item.menu-item-active ion-label { color: #fff; }\n\nion-menu ion-item.menu-item-active .menuimg { filter: brightness(0) invert(1); }\n\n.reports-menu-group {\n    margin: 2px 0;\n}\n\n.reports-menu-group ion-accordion > ion-item {\n    --background: transparent;\n    --color: #4d617d;\n}\n\n.reports-menu-group ion-accordion.menu-accordion-active > ion-item {\n    --color: #ff6b1a;\n    font-weight: 700;\n}\n\n.reports-menu-group ion-accordion > ion-list {\n    padding: 0 0 0 12px;\n}\n\n.reports-menu-group ion-accordion > ion-list ion-item {\n    --min-height: 40px;\n    --padding-start: 14px;\n    font-size: 12px;\n}\n\n.menuimg {\n    width: 30px;\n    margin-right: 24px;\n}\n\n.logo {\n    width: 90px;\n    margin: 0 auto;\n    display: block;\n    padding: 0px 0 17px;\n}\n\n.user_info {\n    display: flex;\n    align-items: center;\n    position: relative;\n    padding: 14px 14px 10px;\n\n    .back_image {\n        height: 40px;\n        width: 40px;\n        min-width: 40px;\n        border-radius: 100%;\n        background: lightgrey;\n    }\n\n    ion-label {\n        font-family: 'semi-bold';\n        margin-left: 16px;\n    }\n\n    ion-icon {\n        position: absolute;\n        right: 16px;\n        color: #a0abba;\n    }\n}\n\n.header_div {\n    display: flex;\n    align-items: center;\n    padding: 16px;\n    padding-right: 0px;\n\n    ion-label {\n        color: grey;\n        text-transform: uppercase;\n        padding-right: 16px;\n        font-size: 12px;\n        white-space: nowrap;\n    }\n\n    div {\n        width: 100%;\n        height: 1px;\n        background: lightgrey;\n    }\n}\n\n.image_div {\n    padding: 0;\n}\n\nion-item {\n    ion-label {\n        font-family: 'medium';\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
